import * as React from 'react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Alert from '@mui/material/Alert';
import { AlertTitle } from '@mui/material';

Message.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  details: PropTypes.object
};

export default function Message({ open, setOpen, details}) {

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const action = (
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
  );

  return (
      <Snackbar
        open={open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        onClose={handleClose}
        message="Note archived"
        action={action}
      >
      <Alert onClose={handleClose} severity={details.severity} sx={{ width: '100%' }}>
      <AlertTitle>{details.severity}</AlertTitle>
          {details.message}
        </Alert>
        </Snackbar>
  );
}
